/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createJobResultOfDanglingAssignmentsCleanUpJobStatusResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type JobResultOfDanglingAssignmentsCleanUpJobStatusResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/jobs/dangling-image-assignments-clean-up/progress/{trackingId}
 */
export interface WithTrackingItemRequestBuilder extends BaseRequestBuilder<WithTrackingItemRequestBuilder> {
    /**
     * Return the status and findings of a dangling image assignments clean up job
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<JobResultOfDanglingAssignmentsCleanUpJobStatusResponse>}
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<JobResultOfDanglingAssignmentsCleanUpJobStatusResponse | undefined>;
    /**
     * Return the status and findings of a dangling image assignments clean up job
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithTrackingItemRequestBuilderUriTemplate = "{+baseurl}/api/jobs/dangling-image-assignments-clean-up/progress/{trackingId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithTrackingItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: WithTrackingItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createJobResultOfDanglingAssignmentsCleanUpJobStatusResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
